import { AlertContext, Confirmation_, device, Grey_Link, Red_, Slider_ } from 'monica-alexandria'
import React, { useContext, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import l from "../../../services/api/Landings";
import { alertMessage } from '../../../utils/messagesAlerts';

const CrmArchivedLeads = styled.div`

  .SliderWrapper {
    max-width: 30%;

    @media ${device.md} {
      max-width: 100%;
    }
  }

  `
const ArchivedList = styled.div`
  height: 100%;
  overflow-y: auto;
  display: flex;
    flex-direction: column;
    gap: 1rem;
  
`;

const ArchivedBulkActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 4rem 1rem 4rem;

  @media ${device.md} {
    padding: 0 0 1rem 0;
  }
`;

const LeadRow = styled.div`
  padding: 1rem;
  border-bottom: 1px solid ${p => p.theme.low};
`;


const ArchivedLeadItem = styled.div`
  background: ${p=> p.theme.mid};
  cursor: pointer;
  padding: var(--smallPads);
  border-radius: var(--smallRadius);
  margin: 0 4rem;
  /* width: 100%; */

  @media ${device.md} {
    /* padding: 0 2rem; */
    margin: 0px;
  }
`;

const ArchivedLeadItemHeader = styled.div`

`
const ArchivedLeadActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 1rem;
  padding-top: 1rem;
`;

export default function Crm_Archived_Leads(props) {
    const {t} = useTranslation();
	const {alerts,setAlerts} = useContext(AlertContext);
    const [confirmDlt, setConfirmDlt] = useState(false);
    const [deletingAll, setDeletingAll] = useState(false);

    const handleArchivedScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;

        if (scrollHeight - scrollTop <= clientHeight + 50) {
            props.fetchMoreArchivedLeads();
        }
    };

    const handleRestore = async (leadId) => {
    try {
        const res = await l.restoreLead(leadId);
        const restoredLead = res?.data?.lead;

        console.log('restoredLEAD', restoredLead);
        
        // if (!restoredLead) return;

        // Reload from backend so the restored lead lands in the backend-selected column.
        props.onLeadRestored?.(restoredLead);

        // 2️⃣ Remove lead from archived leads list
        props.removeFromArchives(leadId);

        alertMessage(alerts, setAlerts, t("Lead restored"), "Success");
        // props.onClose();
    } catch (err) {
        alertMessage(alerts, setAlerts, t("Failed to restore lead"), "Error");
    }
    };


    const handleDelete = async (leadId) => {
    try {
        await l.deleteLead(leadId);

        // remove from archived UI
        props.removeFromArchives(leadId);

        alertMessage(alerts, setAlerts, t("Lead deleted permanently"), "Success");
    } catch (err) {
        alertMessage(alerts, setAlerts, t("Failed to delete lead"), "Error");
    }
};

    const handleDeleteAll = async () => {
      const leadIds = props.archivedLeads.map((lead) => lead._id).filter(Boolean);
      if (!leadIds.length) return;

      try {
        setDeletingAll(true);
        const results = await l.deleteLeads(leadIds);
        const failedCount = results.filter(
          (result) => result.status === "rejected" || result.value === false
        ).length;

        const successIds = leadIds.filter((_, index) => {
          const result = results[index];
          return result?.status === "fulfilled" && result?.value !== false;
        });

        if (successIds.length) {
          props.removeManyFromArchives?.(successIds);
        }

        if (!failedCount) {
          alertMessage(alerts, setAlerts, t("Archived leads deleted permanently"), "Success");
        } else {
          alertMessage(alerts, setAlerts, t("Some archived leads could not be deleted"), "Error");
        }
      } catch (err) {
        alertMessage(alerts, setAlerts, t("Failed to delete archived leads"), "Error");
      } finally {
        setDeletingAll(false);
      }
    };

  return (
    <CrmArchivedLeads>

    {confirmDlt && (

        <Confirmation_
            message={
              confirmDlt === 'all'
                ? t("Are you sure you want to delete all archived leads permanently?")
                : t("Are you sure you want to delete this lead permanently?")
            }
            no={t("No")}
            onNo={() => !deletingAll && setConfirmDlt(false)}
            onYes={() => {
                if (confirmDlt === 'all') {
                  handleDeleteAll();
                  setConfirmDlt(false);
                  return;
                }

                handleDelete(confirmDlt);
                setConfirmDlt(false);
            }}
            yes={t("Yes")}
        />
    )}
      <Slider_
        title={t("Archived Leads")}
        iconGreyLeft='Xicon'
        iconMainRight='Xicon'
        grey={t("Cancel")}
        onGrey={props.onClose}
        onClose={props.onClose}
      >
        {props.archivedLeads.length === 0 && (
            <p>{t("No archived leads found")}</p>
        )}
        {props.archivedLeads.length > 0 && (
            <ArchivedBulkActions>
                <Red_
                    text={deletingAll ? t("Deleting...") : t("Delete all")}
                    iconRight='Delete'
                    size='small'
                    onClick={() => !deletingAll && setConfirmDlt('all')}
                />
            </ArchivedBulkActions>
        )}
        <ArchivedList onScroll={handleArchivedScroll}>
            {props.archivedLeads.map(lead => (
                <ArchivedLeadItem>
                    <ArchivedLeadItemHeader onClick={()=>props.openLeadEditor(lead.columnId, lead)}>
                        <h4>{lead.FullName || (lead.Name || lead.Surname
                            ? `${lead.Name || ""} ${lead.Surname || ""}`
                            : t("New Lead"))}</h4>
                    </ArchivedLeadItemHeader>

                    <ArchivedLeadActions>
                        <Grey_Link text={t('Restore')} iconLeft='Undo' noPadding size='small' onClick={() => handleRestore(lead._id)}/>
                        <Grey_Link text={t('Delete')} iconLeft='Delete' noPadding size='small' onClick={() => setConfirmDlt(lead._id)}   /> 
                    </ArchivedLeadActions>
                </ArchivedLeadItem>
            ))}
            {/* {archivedLoading && <Spinner />} */}
        </ArchivedList>
      </Slider_>
    </CrmArchivedLeads>
  )
}
